export function FormatTime(time:number):string {
    return new Date(time * 1000).toISOString().substring(14, 19);
}